export const setTitleWithCount = (count: number): void => {
  // Get the base title by removing any count at the beginning
  const baseTitle: string = document.title.replace(/^\(\d*\)\s*/, '');

  // Set the updated title
  document.title = `${count ? `(${count})` : ''} ${baseTitle}`;
};
